// extracted by mini-css-extract-plugin
export default {"root":"ListCardInfo_root__DDtQZ"};